import React from 'react';
import { Box, CircularProgress, Heading, Image, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { userProgressType } from '../../../../hooks/V2/useUserActivity';
import Lottie from 'react-lottie-player';
import successLottie from '../../../assets/lottie/successLottie.json';

interface Props {
	resource: {
		_id: string;
		label: string;
	};
	resourceProgress?: userProgressType;
}

const ResourceItemCard = ({ resource, resourceProgress }: Props) => {
	const navigate = useNavigate();
	const currentPath = window.location.pathname;

	return (
		<Box
			cursor="pointer"
			w="full"
			maxW="361px"
			onClick={() => {
				navigate(`${currentPath}/resource/${resource?._id}`);
			}}
			borderRadius={'16px'}
			boxShadow={'0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)'}
		>
			<Image position={'absolute'} src="/images/block-item-card.svg" />
			<Box h="full" display="flex" flexDir="column">
				<Box display={'flex'} textAlign={'center'} alignItems={'center'} minH="148px" bgColor={'#6FCD9E'} borderTopRadius={'16px'}>
					<Heading as="h3" color="#fff" mx="auto" maxW="90%">
						{resource?.label}
					</Heading>
				</Box>
				<Box
					flex="1"
					w="full"
					display={'flex'}
					alignItems={'center'}
					justifyContent={'space-between'}
					borderTop="#E5E5E5"
					borderBottomRadius={'16px'}
					p="10px"
					bgColor={'#FFF'}
					border="1px solid #E5E5E5"
				>
					<Box w="full">
						<Box boxSize="30px" display={'flex'} w="full" alignItems={'center'} justifyContent="space-between">
							<Text textStyle={'body1-md'}>{resource?.label}</Text>

							{resourceProgress && resourceProgress?.completionPercentage > 0 ? (
								resourceProgress?.completionPercentage >= 100 ? (
									<Box w="40px" p={''}>
										<Lottie loop animationData={successLottie} play style={{ width: '100%' }} />
									</Box>
								) : (
									<CircularProgress size="30px" value={resourceProgress?.completionPercentage}></CircularProgress>
								)
							) : null}
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default ResourceItemCard;
